import React, { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { CompetitionsPrizePlacesWidget } from 'widgets/competitions-b2b/prize-places';

export const PrizePlacesPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Призовые места'));
    dispatch(setActionBtnTitle('Редактировать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, [dispatch]);

  return <CompetitionsPrizePlacesWidget />;
};
